/**
 * Some browsers are configured to block any storage, and this affects both reads
 * and writes. This function wraps the attempt to read and just returns an empty
 * string if an exception is thrown or the localStorage object doesn't exist.
 *
 * This simplifies code paths in some cases.
 */
export function safeLocalStorageGetItem(key: string): string | null {
  try {
    return window.localStorage?.getItem(key)
  } catch {
    return null
  }
}
